import { useState } from "react";
import api from "../api/api";
import { useDialog } from "./DialogProvider";
import { X, Loader2 } from "lucide-react";

export function CreateNoteModal({
  open,
  onClose,
  referenceType = "general",
  referenceId = null,
  onSuccess,
}) {
  const { toast } = useDialog();
  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState("");
  const [category, setCategory] = useState("general");
  const [priority, setPriority] = useState("medium");

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!note.trim()) {
      toast({ type: "error", title: "Error", message: "Isi catatan wajib diisi." });
      return;
    }

    setLoading(true);
    try {
      const payload = {
        reference_type: referenceType,
        reference_id: referenceId,
        note: note.trim(),
        category,
        priority,
      };

      await api.post("/accountant/notes", payload);
      toast({ type: "success", title: "Sukses", message: "Catatan berhasil dibuat." });
      
      // reset
      setNote("");
      setCategory("general");
      setPriority("medium");
      
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      toast({
        type: "error",
        title: "Gagal",
        message: err.response?.data?.message || "Gagal membuat catatan.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-md scale-100 transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
          <h3 className="text-base font-semibold leading-6 text-slate-900">
            Buat Laporan / Catatan Masalah
          </h3>
          <button
            onClick={onClose}
            className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-50 hover:text-slate-500"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="px-5 py-4">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700">Kategori</label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              >
                <option value="general">Umum</option>
                <option value="cash_discrepancy">Selisih Kas</option>
                <option value="stock_discrepancy">Selisih Stok</option>
                <option value="payment_verification">Verifikasi Pembayaran</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700">Prioritas</label>
              <select
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
              >
                <option value="low">Rendah (Low)</option>
                <option value="medium">Menengah (Medium)</option>
                <option value="high">Tinggi (High)</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700">Catatan</label>
              <textarea
                rows={4}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Tulis detail temuan di sini..."
                className="mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                required
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              disabled={loading}
            >
              Batal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center justify-center rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-50"
            >
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Simpan Catatan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
